import { render, staticRenderFns } from "./PaymentExpire.vue?vue&type=template&id=1b08e880&"
import script from "./PaymentExpire.vue?vue&type=script&lang=js&"
export * from "./PaymentExpire.vue?vue&type=script&lang=js&"
import style0 from "./PaymentExpire.vue?vue&type=style&index=0&id=1b08e880&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports